import ContentHighlightCatalogVisibilityAlert from './ContentHighlightCatalogVisibilityAlert';
import ContentHighlightCatalogVisibilityHeader from './ContentHighlightCatalogVisibilityHeader';
import ContentHighlightCatalogVisibilityRadioInput from './ContentHighlightCatalogVisibilityRadioInput';

const ContentHighlightCatalogVisibility = () => (
  <>
    <ContentHighlightCatalogVisibilityHeader />
    <ContentHighlightCatalogVisibilityAlert />
    <ContentHighlightCatalogVisibilityRadioInput />
  </>
);

export default ContentHighlightCatalogVisibility;
